export const mapper = (i) => ({ id: i?.id, value: i.name, label: i.label ? i.label : i.name, ...i });

export const userMentionMapper = (i) => ({
    text: `${i.firstName} ${i.lastName}`,
    value: `${i.firstName} ${i.lastName}`,
    url: i.userName,
});

const mainCardModalStyles = {
    width: '140rem',
    overflow: 'auto',
};

const mainCardModalStylesMobile = {
    overflow: 'hidden',
    overflowY: 'auto',
    padding: '0',
};

const getMainCardModalStyles = (isMobile: boolean) => {
    if (isMobile) return mainCardModalStylesMobile;
    return mainCardModalStyles;
};

const mainCardRootStyles = {
    overflow: 'auto',
};

const mainCardRootStylesMobile = {
    paddingBottom: '80px',
    padding: '8px',
};

const getMainCardRootStyles = (isMobile: boolean) => {
    if (isMobile) return mainCardRootStylesMobile;
    return mainCardRootStyles;
};

export const getMainCardStyles = (isMobile: boolean) => {
    const mainCardModalStyles = getMainCardModalStyles(isMobile);
    const mainCardRootStyles = getMainCardRootStyles(isMobile);

    return {
        mainCardModalStyles,
        mainCardRootStyles,
    };
};
